import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "@styles/components/ui/TopAnnouncementBar.scss";

const ANNOUNCEMENTS = [
  {
    id: 1,
    desc: {
      hk: "【記低大日子：9月19日】ClubS 會員獨家 BIG 禮遇！密切留意我們最新消息，鎖定機會，一齊記錄每個 BIG moment！",
      en: "[Save Sep 19] Exclusive BIG perks for ClubS members! Stay tuned for our latest updates, seize the opportunity, and record every BIG moment together!",
    },
  },
];

const TopAnnouncementBar = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isChinese = i18n.language === "hk";

  useEffect(() => {
    if (!isVisible || ANNOUNCEMENTS.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % ANNOUNCEMENTS.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  return (
    <Box className="hsbc-announcement-bar">
      <Box className="announcement-track">
        {ANNOUNCEMENTS.map((item, idx) => (
          <Box
            key={item.id}
            className={`announcement-item ${idx === currentIndex ? "active" : ""}`}
          >
            <Typography component="span" className="announcement-desc">
              {isChinese ? item.desc.hk : item.desc.en}
            </Typography>
          </Box>
        ))}
      </Box>

      <IconButton
        className="close-btn"
        size="small"
        onClick={handleClose}
        aria-label="close announcement"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default TopAnnouncementBar;